/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import ReviewDetails from "./ReviewDetails.container";

export default ReviewDetails;
